import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      const errorMessage =
        (this.state.error && this.state.error.message) ||
        (this.state.error && this.state.error.toString()) ||
        '';

      const isAuthError = /user not authenticated|session|auth/i.test(errorMessage);
      const message = isAuthError
        ? 'Your session may have expired. Please sign in again.'
        : "We're sorry, but something unexpected happened. Please try refreshing the page.";

      return (
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="max-w-md mx-auto text-center p-6">
            <div className="mb-4">
              <h1 className="text-2xl font-bold text-destructive mb-2">Oops! Something went wrong</h1>
              <p className="text-muted-foreground mb-4">{message}</p>
            </div>

            <div className="space-y-3">
              {isAuthError && (
                <Link
                  to="/signin"
                  className="block w-full px-4 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90 transition-colors"
                >
                  Sign In
                </Link>
              )}
              <button
                onClick={() => window.location.reload()}
                className="w-full px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
              >
                Refresh Page
              </button>

              <button
                onClick={() => window.history.back()}
                className="w-full px-4 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90 transition-colors"
              >
                Go Back
              </button>
            </div>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mt-6 text-left">
                <summary className="cursor-pointer text-sm font-medium text-muted-foreground">
                  Error Details (Development Only)
                </summary>
                <div className="mt-2 p-3 bg-muted rounded text-xs font-mono overflow-auto">
                  <div className="text-destructive font-bold">
                    {this.state.error && this.state.error.toString()}
                  </div>
                  <div className="mt-2 text-muted-foreground">
                    {this.state.errorInfo.componentStack}
                  </div>
                </div>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
